export default __webpack_public_path__ + "10ec3f14f23fac6a44db2ef463965ed5.png";